const OrderModel = {
    shippingRates: (shippingRateIds, items = {}) => items.filter((item) => item.type === 'shipping_rate' && shippingRateIds.indexOf(item.id) !== -1),

    selectedShippingRate: (shippingRateIds, items = {}) => items.filter((item) => item.type === 'shipping_rate' && shippingRateIds.indexOf(item.id) !== -1 && item.attributes.selected),

    find: (orderId, orders = []) => {
        const radix = 10;
        return orders.find((order) => parseInt(order.id, radix) === parseInt(orderId, radix));
    },
};

export default OrderModel;



/** WEBPACK FOOTER **
 ** ./src/services/order-model.js
 **/